import {ColorPicker} from '@crema/modules/thirdParty';
export default ColorPicker;
